<dff-side [observable]="vm$">
  @if (vm$ | async; as vm) {
    <dff-side-titel>{{ vm.sideTitel }}</dff-side-titel>
    <mat-accordion [multi]="!vm.erMobilVisning" id="mineoplysningersiden">
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h2 class="panel-header">Mine oplysninger</h2>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <e-forsyning-stamoplysninger></e-forsyning-stamoplysninger>
      </mat-expansion-panel>
      @if (vm.visEBoksSektion) {
        <mat-expansion-panel [expanded]="!vm.erMobilVisning" id="EBoksTilmelding">
          <mat-expansion-panel-header>
            <mat-panel-title> <h2 class="panel-header">Tilmeld e-Boks</h2> </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <e-boks-tilmelding [disabled]="!vm.erForbruger"></e-boks-tilmelding>
          </ng-template>
        </mat-expansion-panel>
      }
      <mat-expansion-panel [expanded]="!vm.erMobilVisning">
        <mat-expansion-panel-header>
          <mat-panel-title> <h2 class="panel-header">Ejers oplysninger</h2></mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <e-forsyning-ejeroplysninger></e-forsyning-ejeroplysninger>
        </ng-template>
      </mat-expansion-panel>
      <mat-expansion-panel [expanded]="!vm.erMobilVisning">
        <mat-expansion-panel-header>
          <mat-panel-title><h2 class="panel-header">Loginoplysninger</h2></mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <e-forsyning-loginoplysninger></e-forsyning-loginoplysninger>
        </ng-template>
      </mat-expansion-panel>
      <mat-expansion-panel [expanded]="!vm.erMobilVisning">
        <mat-expansion-panel-header>
          <mat-panel-title><h2 class="panel-header">Ejendomsoplysninger</h2> </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <e-forsyning-ejendomsoplysninger></e-forsyning-ejendomsoplysninger>
        </ng-template>
      </mat-expansion-panel>
      <mat-expansion-panel [expanded]="!vm.erMobilVisning">
        <mat-expansion-panel-header>
          <mat-panel-title><h2 class="panel-header">Tilknyttede forbruger</h2></mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          <e-forsyning-tilknyt-forbruger></e-forsyning-tilknyt-forbruger>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>
  }
</dff-side>
